import { keyframes, css } from 'styled-components';

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(359deg);
  }
`;

export const rotate360Rule = css`
  ${rotate360} 0.5s linear infinite
`;

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const fadeInRule = css`
  ${fadeIn} 0.5s linear forwards
`;

export default {
  fadeInRule,
  rotate360Rule,
};
